import { useEffect } from 'react'
import { learningAudioCache } from './learning-audio-cache'

export function useWarmLearningAudio(sources: readonly string[]) {
  const signature = JSON.stringify(sources)
  useEffect(() => {
    const leases = (JSON.parse(signature) as string[]).filter(Boolean).map(source => learningAudioCache.acquire(source))
    leases.forEach(lease => { void lease.ready.catch(() => undefined) })
    return () => leases.forEach(lease => lease.release())
  }, [signature])
}
